// 项目详情>tab内容
function pro_detail_tabContent(type) {
  if (['farmland', 'construction', 'operating', 'house', 'resource', 'forest', 'wasteland'].includes(type)) {
    return 'otherTradeKind_tabContent'
  }

  if (['smallmicro'].includes(type)) {
    return 'smallmicro_tabContent'
  }
}

// 项目item型
function pro_item(type) {
  if (['farmland', 'construction', 'operating', 'house', 'resource', 'forest', 'wasteland'].includes(type)) {
    return 'otherTradeKind_proItem'
  }

  if (['smallmicro'].includes(type)) {
    return 'smallmicro_proItem'
  }
}

// 项目list型
function pro_list(type) {
  if (['farmland', 'construction', 'operating', 'house', 'resource', 'forest', 'wasteland'].includes(type)) {
    return 'otherTradeKind_proList'
  }

  if (['smallmicro'].includes(type)) {
    return 'smallmicro_proList'
  }
}

// 项目公告字段元信息
function pro_fieldMeta(type) {
  if (['farmland', 'construction', 'operating', 'house', 'resource', 'forest', 'wasteland'].includes(type)) {
    return 'otherTradeKind_pro_fieldMeta'
  }

  if (['smallmicro'].includes(type)) {
    return 'smallmicro_pro_fieldMeta'
  }
}

export {
  pro_fieldMeta,
  pro_detail_tabContent,
  pro_item,
  pro_list
}
